import { useFunnelModuleDescription } from "../../onboarding/services/OnboardingService";
import "./FunnelModuleDescription.scss";

interface FunnelModuleDescriptionProps {
  moduleId: string;

  fallback?: string;

  className?: string;
}

/**
 * Zeigt eine personalisierte Beschreibung fuer ein Modul an.
 */
export default function FunnelModuleDescription({
  moduleId,
  fallback,
  className = "",
}: FunnelModuleDescriptionProps) {
  const { data, isLoading, error } = useFunnelModuleDescription(moduleId, true);

  // Fallback anzeigen, solange geladen wird oder bei Fehler
  if (isLoading || error || !data) {
    return (
      <p className={`module-description ${className}`}>
        {fallback || data?.fallbackDescription || ""}
      </p>
    );
  }

  // Personalisierte Beschreibung anzeigen
  return (
    <p
      className={`module-description ${className} ${
        data.personalized ? "module-description--personalized" : ""
      }`}
      title={
        data.personalized
          ? `Personalisiert fuer deine Branche: ${data.description}`
          : data.fallbackDescription
      }
    >
      {data.description}
    </p>
  );
}